import { render, staticRenderFns } from "./CommissionPayRateColumn.vue?vue&type=template&id=00a464d8&scoped=true&"
import script from "./CommissionPayRateColumn.vue?vue&type=script&lang=js&"
export * from "./CommissionPayRateColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a464d8",
  null
  
)

export default component.exports